<template>
	<el-dialog title="APP 下载" :visible.sync="visible" width="360px" append-to-body :close-on-click-modal="true">
		<div class="app-download-box">
			<div class="qr-wrap">
				<img v-if="qrDataUrl" :src="qrDataUrl" class="qr-img" alt="APP下载二维码" />
				<i v-else class="el-icon-loading qr-loading"></i>
			</div>
			<div class="dl-plat"><span>🤖 Android</span><i>/</i><span>🍏 iOS</span></div>
			<div class="dl-tip">使用手机<b>浏览器 / 相机</b>扫码下载</div>
			<div class="dl-warn">⚠️ 请勿使用微信扫码，微信会拦截下载</div>
			<div class="dl-sub">同一个码自动识别机型 · 安卓与 iOS 各自跳到对应安装包</div>
			<div class="dl-desktop">
				<div class="dl-desktop-links">
					<a :href="desktopWinUrl" target="_blank" rel="noopener">💻 Windows 版</a>
					<i>/</i>
					<a :href="desktopMacUrl" target="_blank" rel="noopener">🍏 Mac(苹果芯片)</a>
					<i>/</i>
					<a :href="desktopMacIntelUrl" target="_blank" rel="noopener">🍏 Mac(Intel)</a>
				</div>
				<span class="dl-desktop-tip">电脑双击安装即用，与手机/网页消息实时同步</span>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import QRCode from 'qrcode';

// 聚合码入口：跟随当前 origin（域名可达时扫出域名、纯IP应急通道扫出IP），
// 该页按 UA 分流（安卓 → 自建服务器直链 / iOS → OTA manifest），
// 两端共用这一个二维码；换分发地址只需改服务器上的 app-download.html，二维码永不失效
const DOWNLOAD_URL = window.location.origin + '/download/app';
// Windows 桌面客户端安装包(随 origin 拼接, 域名/纯IP应急通道均可下载)
const DESKTOP_WIN_URL = window.location.origin + '/download/BoxIM-Setup.exe';
// Mac 桌面客户端安装包(dmg, Apple Silicon)
const DESKTOP_MAC_URL = window.location.origin + '/download/BoxIM.dmg';
// Mac 桌面客户端安装包(dmg, Intel 芯片)
const DESKTOP_MAC_INTEL_URL = window.location.origin + '/download/BoxIM-Intel.dmg';

export default {
	name: 'appDownload',
	data() {
		return {
			visible: false,
			qrDataUrl: '',
			desktopWinUrl: DESKTOP_WIN_URL,
			desktopMacUrl: DESKTOP_MAC_URL,
			desktopMacIntelUrl: DESKTOP_MAC_INTEL_URL
		};
	},
	methods: {
		open() {
			this.visible = true;
			this.genQr();
		},
		async genQr() {
			if (this.qrDataUrl) {
				return;
			}
			try {
				this.qrDataUrl = await QRCode.toDataURL(DOWNLOAD_URL, {
					width: 220,
					margin: 1,
					color: { dark: '#000000', light: '#ffffff' }
				});
			} catch (e) {
				console.error('生成二维码失败', e);
				this.$message.error('生成二维码失败');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.app-download-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0 4px;

	.qr-wrap {
		width: 220px;
		height: 220px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #ebeef5;
		border-radius: 8px;
		background: #fff;

		.qr-img {
			width: 200px;
			height: 200px;
		}

		.qr-loading {
			font-size: 28px;
			color: #409eff;
		}
	}

	.dl-plat {
		margin-top: 14px;
		display: flex;
		align-items: center;
		font-size: 13px;
		color: #2f5fe8;
		font-weight: 600;

		i {
			margin: 0 8px;
			color: #c0c4cc;
			font-style: normal;
		}
	}

	.dl-tip {
		margin-top: 16px;
		font-size: 14px;
		color: #333;

		b {
			color: #2f5fe8;
		}
	}

	.dl-warn {
		margin-top: 8px;
		font-size: 12px;
		color: #e67700;
		background: #fff7e8;
		border: 1px solid #ffe1a8;
		border-radius: 6px;
		padding: 4px 10px;
	}

	.dl-sub {
		margin-top: 8px;
		font-size: 12px;
		color: #999;
		text-align: center;
	}

	.dl-desktop {
		margin-top: 14px;
		padding-top: 12px;
		border-top: 1px dashed #e4e7ed;
		display: flex;
		flex-direction: column;
		align-items: center;

		.dl-desktop-links {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			justify-content: center;

			i {
				margin: 0 6px;
				color: #c0c4cc;
				font-style: normal;
			}
		}

		a {
			font-size: 13px;
			font-weight: 600;
			color: #2f5fe8;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		.dl-desktop-tip {
			margin-top: 4px;
			font-size: 12px;
			color: #999;
		}
	}
}
</style>
